import { apiGet, apiPut, throwApiError } from "../utils";

export const VerificationRequestStatus = {
  Pending: "pending",
  Fulfilled: "fulfilled",
  Cancelled: "cancelled",
};

export const getVerificationRequests = async (page, perPage) => {
  const response = await apiGet("/verification-requests", { page, perPage });
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getVerificationRequest = async (id) => {
  const response = await apiGet(`/verification-requests/${id}`);
  const { message, ...verificationRequest } = await response.json();

  throwApiError(message);

  return verificationRequest;
};

export const changeVerificationRequestStatus = async (id, status) => {
  const response = await apiPut(`/verification-requests/${id}/status`, {
    status,
  });
  const { message, ...verificationRequest } = await response.json();

  throwApiError(message);

  return verificationRequest;
};

export const getIdentityDocument = async (id) => {
  const response = await apiGet(
    `/verification-requests/${id}/identity-document`,
  );
  if (response.status !== 200) {
    alert("Error fetching identity document!");
    return;
  }

  const url = await response.text();

  return url;
};
